var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "pl-0" },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-1 mr-4",
              attrs: { vertical: "", label: "Тип доставки:" }
            },
            [
              _c("b-form-select", {
                attrs: {
                  value: _vm.filterDeliveryType,
                  options: _vm.deliveryTypeOptions
                },
                on: { input: _vm.changedDeliveryType }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b086996", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b086996","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeliveryTypeFilter.vue
// module id = null
// module chunks = 